export default "__VITE_ASSET__f71ed484__"